var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "pb-2" },
    [
      _c(
        "e-filters",
        {
          ref: "filters",
          attrs: {
            title: _vm.$t("Filtros"),
            searching: _vm.fetching,
            "search-text": _vm.$t("Consultar"),
          },
          on: { search: _vm.getData, reset: _vm.resetFilters },
        },
        [
          _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("e-store-combo", {
                        attrs: { id: "filters-store", required: "" },
                        on: { input: _vm.onChangeStore },
                        model: {
                          value: _vm.filters.storeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "storeId", $$v)
                          },
                          expression: "filters.storeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("e-checking-account-combo", {
                        attrs: {
                          type: ["InternetBanking"],
                          "store-id": _vm.filters.storeId,
                          required: "",
                          "active-options": "",
                        },
                        on: { input: _vm.setBalanceEmpty },
                        model: {
                          value: _vm.filters.checkingAccountId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "checkingAccountId", $$v)
                          },
                          expression: "filters.checkingAccountId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm.balance
        ? [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { staticClass: "mb-1", attrs: { md: "4" } },
                  [
                    _c("e-total-summary-card", {
                      attrs: {
                        title: _vm.$t("Saldo disponível"),
                        "title-class": "text-success",
                        value: _vm.balance.availableAmount || 0,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { staticClass: "mb-1", attrs: { md: "4" } },
                  [
                    _c("e-total-summary-card", {
                      attrs: {
                        title: _vm.$t("Saldo bloqueado"),
                        "title-class": "text-danger",
                        value: _vm.balance.blockedAmount || 0,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { staticClass: "mb-1", attrs: { md: "4" } },
                  [
                    _c("e-total-summary-card", {
                      attrs: {
                        title: _vm.$t("Aplicação automática"),
                        "title-class": "text-info",
                        value: _vm.balance.automaticallyInvestedAmount || 0,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("p", { staticClass: "text-muted text-right" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("Consultado em")) +
                  ": " +
                  _vm._s(_vm._f("datetime")(_vm.consultedAt, "-", true)) +
                  " "
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }